import {Icon} from '@wandb/components';
import React from 'react';

import {type WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {usePinningActions} from '../hooks/usePinningActions';
import {RowHeaderMenuOption} from './RowHeaderMenuOption';

type RunPinningAndBaselineMenuOptionsProps = {
  row: WBTableRowWithRunSetInfo;
};

export function RunPinningAndBaselineMenuOptions({
  row,
}: RunPinningAndBaselineMenuOptionsProps) {
  const {
    baselineLabel,
    canBaselineRun,
    canPinRun,
    canUnpinRun,
    isBaseline,
    isPinned,
    onBaselineClick,
    onPinClick,
    pinLabel,
    pinInfoLabel,
  } = usePinningActions({row});

  return (
    <>
      {!isBaseline && (canPinRun || canUnpinRun) && (
        <RowHeaderMenuOption
          data-dd-action-name={isPinned ? 'Unpin run' : 'Pin run'}
          icon={<Icon icon="pin" />}
          infoLabel={pinInfoLabel}
          label={pinLabel}
          onSelect={onPinClick}
          disabled={!canPinRun && !isPinned}
        />
      )}
      {canBaselineRun && (
        <RowHeaderMenuOption
          // "Replace baseline" (label when another run is baseline) also sets a
          // baseline, so it reports as "Set baseline"
          data-dd-action-name={isBaseline ? 'Remove baseline' : 'Set baseline'}
          icon={<Icon icon="bookmark-my-projects" />}
          label={baselineLabel}
          onSelect={onBaselineClick}
          disabled={!canPinRun && !isPinned}
        />
      )}
    </>
  );
}
